import { call, put, takeLeading } from 'redux-saga/effects'
import I18n from 'i18n'
import { getUnreadMessagesCount } from 'api/chat/Get'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/chat.action'

async function handleGetUnreadMessagesCount() {
  return await getUnreadMessagesCount()
}

function* getUnreadMessagesCountEffectSaga() {
  try {
    const data = yield call(handleGetUnreadMessagesCount)
    yield put(fromActions.Actions.getUnreadMessagesCountSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* getUnreadMessagesCountWatcherSaga() {
  yield takeLeading(
    fromActions.GET_UNREAD_MESSAGES_COUNT,
    getUnreadMessagesCountEffectSaga
  )
}
